import React, { useState } from 'react';
import '../../styles/search/Search.css';
import 'react-date-range/dist/styles.css';
import '../../styles/search/DateRangePicker.css';
import { DateRangePicker } from 'react-date-range';
import es from 'date-fns/locale/es';
import LocationCityIcon from '@material-ui/icons/LocationCity';

import PeopleIcon from '@material-ui/icons/People';
import { useHistory } from 'react-router-dom';

function Search() {
  const history = useHistory();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [people, setPeople] = useState(2);

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  function handleSelect(ranges) {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  }

  return (
    <div className="search">
      <DateRangePicker
        ranges={[selectionRange]}
        onChange={handleSelect}
        className="search__date-range-picker"
        lang="es"
        locale={es}
        color="#f05545"
      />
      <div className="search-details">
        <label className="search-details__label">
          <PeopleIcon />
          &nbsp;Número de huéspedes
        </label>
        <input
          min={0}
          type="number"
          name="people"
          value={people}
          onChange={(e) => setPeople(e.target.value)}
          className="search-details__input"
        />
        <label className="search-details__label">
          <LocationCityIcon />
          &nbsp;Ciudad
        </label>
        <select className="search-details__select">
          <option disabled defaultValue>
            Seleccionar ciudad
          </option>
          <option value="Lima">Lima</option>
          <option value="Arequipa">Arequipa</option>
          <option value="Piura">Piura</option>
          <option value="Ica">Ica</option>
          <option value="Trujillo">Trujillo</option>
        </select>
        <button onClick={() => history.push('/search')}>
          <LocationCityIcon />
          &nbsp; Buscar habitaciones en Manzana
        </button>
      </div>
    </div>
  );
}

export default Search;
